// extracted by mini-css-extract-plugin
export default {"container":"MediaSourceViewer_container__BMQW+"};